import { api } from '../api';
import { IdCompany } from '../../contexts/auth'

export async function createAccessLevelToUser(userID, accessLevel) {
    try {
        const { 
            data 
        } = await api.post(`/company-user?user_id=${userID}&company_id=${IdCompany()}&permissao=${accessLevel}`)
        if(data){
            return data
        }
        return null
    }
    catch (error) {
        return null
    }
};

export async function getAccessLevel() {
    try {
        const { data } = await api.get('/access-level')
        return data
    }
    catch (error) {
        return null
    }
};